import { render, staticRenderFns } from "./teamWrapper.vue?vue&type=template&id=794841ee"
import script from "./teamWrapper.vue?vue&type=script&lang=js"
export * from "./teamWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports